import 'react-notifications/lib/notifications.css'
import { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { FaGem, FaCoins, FaUsers, FaSearch, FaPaperPlane, FaImage, FaTimes, FaUserShield } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import player_services from "../../../services/player_services"
import card_services from "../../../services/card_services"

class AdminPlayers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            players: [],
            selectKey: null,
            order: 'asc',
            loading: false,
            username: null,
            selectedPlayers: [],
            gift_coins: null,
            gift_gems: null,
            sending: false,
            send_email: false,
            email_set: false,
            notif_set: false,
            seen_start_date: '',
            seen_end_date: '',
            register_start_date: '',
            register_end_date: '',
            reason: null,
            subject: null,
            message: null,
            deactivated: false,
            showBudModal: false,
            selectedPlayerForBud: null,
            buds: [],
            loadingBuds: false,
            sendingBud: false,
            selectedBud: null,
            budSearch: '',
            card_power: null,
            upgrading: false,
            adsEnabled: true,
            noAdsEndDate: null,
        }
    }

    componentDidMount = async () => {
        await this.loadBuds()
    }

    loadBuds = async () => {
        try {
            const buds = await card_services.getBuds(false, 'player')
            this.setState({ buds })
        } catch (e) {
            console.error('Error loading buds:', e)
        }
    }

    searchPlayers = async (e) => {
        if (e && e.key !== 'Enter') return

        if (!this.state.username || this.state.username.length < 3) {
            NotificationManager.error('Please set a username with at least 3 chars')
            return
        }
        if (this.state.seen_start_date && this.state.seen_end_date && this.state.seen_start_date > this.state.seen_end_date) {
            NotificationManager.error('Last sign-in start date must be before end date')
            return
        }
        if (this.state.register_start_date && this.state.register_end_date && this.state.register_start_date > this.state.register_end_date) {
            NotificationManager.error('Registration start date must be before end date')
            return
        }

        this.setState({ loading: true })
        try {
            const players = await player_services.searchPlayers(
                this.state.username,
                this.state.email_set,
                this.state.notif_set,
                this.state.deactivated,
                this.state.seen_start_date || null,
                this.state.seen_end_date || null,
                this.state.register_start_date || null,
                this.state.register_end_date || null,
            )
            if (players.length === 0) NotificationManager.warning('No players found :/')
            this.setState({ players, loading: false, selectedPlayers: [] })
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            this.setState({ loading: false })
        }
    }

    selectPlayer = async (player_uuid) => {
        if (!this.state.selectedPlayers.includes(player_uuid)) {
            this.setState({
                selectedPlayers: [...this.state.selectedPlayers, player_uuid]
            })
        } else {
            let selectedPlayers = this.state.selectedPlayers
            const index = selectedPlayers.indexOf(player_uuid);
            selectedPlayers.splice(index, 1);
            this.setState({ selectedPlayers })
        }
    }

    selectAll = async () => {
        if (this.state.selectedPlayers.length === this.state.players.length) {
            this.setState({ selectedPlayers: [] })
        } else {
            let selectedPlayers = []
            for (let p of this.state.players) {
                selectedPlayers.push(p.player_uuid)
            }
            this.setState({ selectedPlayers })
        }
    }

    sendGift = async () => {
        const nb_coins = this.state.gift_coins ? parseInt(this.state.gift_coins) : 0
        const nb_gems = this.state.gift_gems ? parseInt(this.state.gift_gems) : 0

        if (this.state.selectedPlayers.length < 1)
            return NotificationManager.error('Please select at least 1 player')
        if ((!nb_coins || nb_coins <= 0) && (!nb_gems || nb_gems <= 0))
            return NotificationManager.error('Please set at least 1 coin or 1 gem')

        try {
            this.setState({ sending: true })
            const response = await player_services.sendPlayerGift(
                this.state.selectedPlayers,
                nb_coins > 0 ? nb_coins : null,
                nb_gems > 0 ? nb_gems : null,
                this.state.reason,
                this.state.subject,
                this.state.message,
                this.state.send_email,
            )

            if (response && response.not_sent && response.not_sent.length > 0) {
                NotificationManager.warning(`Gift sent partially (${response.not_sent.length} failed)`)
            } else {
                NotificationManager.success('Gift sent successfully')
            }
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        } finally {
            this.setState({ sending: false })
        }
    }

    reorder = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let players = this.state.players
        
        // Check if sorting by date field
        const dateFields = ['created_date', 'last_seen', 'updated_date']
        if (dateFields.includes(key)) {
            if (order === 'asc')
                players.sort((a, b) => new Date(a[key] || 0) - new Date(b[key] || 0))
            else
                players.sort((a, b) => new Date(b[key] || 0) - new Date(a[key] || 0))
        } else {
            if (order === 'asc')
                players.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
            else
                players.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        }
        this.setState({ players })
    }

    openBudModal = (player) => {
        this.setState({ 
            showBudModal: true, 
            selectedPlayerForBud: player,
            selectedBud: null,
            budSearch: '',
            card_power: null,
        })
    }

    closeBudModal = () => {
        this.setState({ 
            showBudModal: false, 
            selectedPlayerForBud: null,
            selectedBud: null,
            budSearch: '',
            card_power: null,
        })
    }

    sendBudCard = async () => {
        if (!this.state.selectedBud) {
            NotificationManager.error('Please select a bud card')
            return
        }

        let card_power = null
        if (this.state.card_power !== null && this.state.card_power !== '') {
            card_power = parseInt(this.state.card_power)
            if (Number.isNaN(card_power) || card_power <= 0) {
                NotificationManager.error('Card power must be a positive number')
                return
            }
        }

        this.setState({ sendingBud: true })
        try {
            const response = await card_services.sendBudToPlayer(
                this.state.selectedBud.bud_uuid,
                this.state.selectedPlayerForBud.player_uuid,
                card_power,
            )
            NotificationManager.success(response.message || 'Card sent successfully')
            this.closeBudModal()
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        } finally {
            this.setState({ sendingBud: false })
        }
    }

    upgradePlayers = async () => {
        if (this.state.selectedPlayers.length < 1) {
            NotificationManager.error('Please select at least 1 player')
            return
        }

        this.setState({ upgrading: true })
        try {
            const response = await player_services.upgradePlayers(
                this.state.selectedPlayers,
                this.state.adsEnabled,
                this.state.noAdsEndDate
            )
            NotificationManager.success(response.message || 'Players upgraded successfully')
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        } finally {
            this.setState({ upgrading: false })
        }
    }

    render() {
        const filteredBuds = this.state.buds.filter(bud =>
            bud.target !== 'business' &&
            (bud.bud_name || '').toLowerCase().includes(this.state.budSearch.trim().toLowerCase())
        )

        return (
            <>
                <AdminLayout 
                    title="Players Management"
                    breadcrumbs={[{ label: 'Players' }]}
                >
                    <div className="space-y-6">
                        {/* Search Section */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                                <FaSearch className="text-blue-600" />
                                Search Players
                            </h3>

                            <div className="space-y-4">
                                <div>
                                    <input 
                                        type="text" 
                                        placeholder="Search by username (min 3 chars) and press Enter" 
                                        onKeyUp={this.searchPlayers} 
                                        onChange={(e) => this.setState({ username: e.target.value })}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none text-lg"
                                    />
                                </div>

                                {/* Filters */}
                                <div className="flex flex-wrap gap-4">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input 
                                            type="checkbox" 
                                            checked={this.state.email_set} 
                                            onChange={() => this.setState({ email_set: !this.state.email_set })}
                                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                        />
                                        <span className="text-sm font-medium text-gray-700">Email Registered</span>
                                    </label>

                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input 
                                            type="checkbox" 
                                            checked={this.state.notif_set} 
                                            onChange={() => this.setState({ notif_set: !this.state.notif_set })}
                                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                        />
                                        <span className="text-sm font-medium text-gray-700">Notifications Active</span>
                                    </label>

                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input 
                                            type="checkbox" 
                                            checked={this.state.deactivated} 
                                            onChange={() => this.setState({ deactivated: !this.state.deactivated })}
                                            className="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
                                        />
                                        <span className="text-sm font-medium text-gray-700">Deactivated</span>
                                    </label>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Last sign-in from</label>
                                        <input
                                            type="date"
                                            value={this.state.seen_start_date}
                                            onChange={(e) => this.setState({ seen_start_date: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Last sign-in to</label>
                                        <input
                                            type="date"
                                            value={this.state.seen_end_date}
                                            min={this.state.seen_start_date || undefined}
                                            onChange={(e) => this.setState({ seen_end_date: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Registered from</label>
                                        <input
                                            type="date"
                                            value={this.state.register_start_date}
                                            onChange={(e) => this.setState({ register_start_date: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Registered to</label>
                                        <input
                                            type="date"
                                            value={this.state.register_end_date}
                                            min={this.state.register_start_date || undefined}
                                            onChange={(e) => this.setState({ register_end_date: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        />
                                    </div>
                                </div>

                                <div className="flex justify-end">
                                    <button
                                        type="button"
                                        onClick={() => this.searchPlayers()}
                                        disabled={this.state.loading}
                                        className="px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors font-medium flex items-center gap-2"
                                    >
                                        <FaSearch /> {this.state.loading ? 'Searching...' : 'Search Players'}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Loading State */}
                        {this.state.loading && (
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 p-8 text-center">
                                <p className="text-gray-600">Loading...</p>
                            </div>
                        )}

                        {/* Results Section */}
                        {!this.state.loading && this.state.players.length > 0 && (
                            <>
                                {/* Results Table */}
                                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                                        <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                                            <FaUsers className="text-blue-600" />
                                            {this.state.players.length} Players Found
                                        </h3>
                                        {this.state.selectedPlayers.length > 0 && (
                                            <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium">
                                                {this.state.selectedPlayers.length} selected
                                            </span>
                                        )}
                                    </div>

                                    <div className="overflow-x-auto">
                                        <table className="w-full">
                                            <thead className="bg-gray-50 border-b border-gray-200">
                                                <tr>
                                                    <th className="px-4 py-3 text-left w-12">
                                                        <input 
                                                            type="checkbox" 
                                                            checked={this.state.selectedPlayers.length === this.state.players.length} 
                                                            onChange={this.selectAll}
                                                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                                                        />
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-32">Avatar</th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors" onClick={() => this.reorder("username")}>
                                                        ⥃ Username
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors" onClick={() => this.reorder("email")}>
                                                        ⥃ Email
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors w-40" onClick={() => this.reorder("created_date")}>
                                                        ⥃ Registration
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors w-40" onClick={() => this.reorder("last_seen")}>
                                                        ⥃ Last Seen
                                                    </th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors w-20" onClick={() => this.reorder("level")}>
                                                        ⥃ Level
                                                    </th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors w-24" onClick={() => this.reorder("nb_games")}>
                                                        ⥃ Games
                                                    </th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-32">Level Progress</th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-20">Notif</th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors w-24" onClick={() => this.reorder("stars")}>
                                                        ⥃ <FaCoins className="inline text-amber-500" />
                                                    </th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 transition-colors w-24" onClick={() => this.reorder("gems")}>
                                                        ⥃ <FaGem className="inline text-purple-600" />
                                                    </th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-40">Ads Status</th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-32">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200">
                                                {this.state.players.map(player => (
                                                    <tr key={`player_${player.player_uuid}`} className="hover:bg-gray-50 transition-colors">
                                                        <td className="px-4 py-3">
                                                            <input 
                                                                type="checkbox" 
                                                                checked={this.state.selectedPlayers.includes(player.player_uuid)} 
                                                                onChange={() => this.selectPlayer(player.player_uuid)}
                                                                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                                                            />
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            {player.avatar && (
                                                                <div 
                                                                    className="w-16 h-16 rounded-lg bg-cover bg-center shadow-md border border-gray-200"
                                                                    style={{ backgroundImage: `url('${player.avatar}')` }}
                                                                />
                                                            )}
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="font-medium text-gray-900">{player.username}</span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="text-sm text-gray-700">{player.email}</span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="text-xs text-gray-600">
                                                                <div>{new Date(player.created_date).toLocaleDateString()}</div>
                                                                <div className="text-gray-500">{new Date(player.created_date).toLocaleTimeString()}</div>
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="text-xs text-gray-600">
                                                                <div>{new Date(player.last_seen).toLocaleDateString()}</div>
                                                                <div className="text-gray-500">{new Date(player.last_seen).toLocaleTimeString()}</div>
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-white font-bold text-sm shadow-md">
                                                                {player.level || 1}
                                                            </span>
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            <span className="font-semibold text-gray-700">{player.nb_games || 0}</span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex flex-col gap-1">
                                                                <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                                                                    <div 
                                                                        className="bg-gradient-to-r from-blue-500 to-indigo-600 h-2 rounded-full transition-all duration-300"
                                                                        style={{ width: `${player.level_progression || 0}%` }}
                                                                    />
                                                                </div>
                                                                <span className="text-xs text-gray-600 text-center">{player.level_progression || 0}%</span>
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            <span className="text-xl">{player.notifications ? "✅" : "❌"}</span>
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            <span className="font-semibold text-amber-600">{player.stars}</span>
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            <span className="font-semibold text-purple-600">{player.gems}</span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            {player.ads ? (
                                                                <div className="flex items-center justify-center gap-1.5">
                                                                    <span className="text-xl">📺</span>
                                                                    <span className="text-xs font-medium text-gray-600">Active</span>
                                                                </div>
                                                            ) : (
                                                                <div className="text-center">
                                                                    <div className="flex items-center justify-center gap-1.5 mb-1">
                                                                        <span className="text-xl">🚫</span>
                                                                        <span className="text-xs font-semibold text-green-600">Ad-Free</span>
                                                                    </div>
                                                                    {player.ads_free_end_date && (
                                                                        <div className="text-xs text-gray-500">
                                                                            Until {new Date(player.ads_free_end_date).toLocaleDateString()}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            <button
                                                                onClick={() => this.openBudModal(player)}
                                                                className="px-3 py-1.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white text-sm rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all font-medium shadow-sm hover:shadow-md flex items-center gap-1.5 mx-auto"
                                                            >
                                                                <FaPaperPlane />
                                                                Send Card
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* Send Gift Section */}
                                <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                                    <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                                        <FaCoins className="text-amber-500" />
                                        Send Gift (Coins and/or Gems)
                                    </h3>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Coins</label>
                                            <input 
                                                type="number" 
                                                placeholder="0" 
                                                min="0"
                                                onChange={(e) => this.setState({ gift_coins: e.target.value })}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Gems</label>
                                            <input 
                                                type="number" 
                                                placeholder="0" 
                                                min="0"
                                                onChange={(e) => this.setState({ gift_gems: e.target.value })}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Reason</label>
                                            <input 
                                                type="text" 
                                                placeholder="Reason for sending gift" 
                                                onChange={(e) => this.setState({ reason: e.target.value })}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Subject</label>
                                            <input 
                                                type="text" 
                                                placeholder="Email subject" 
                                                onChange={(e) => this.setState({ subject: e.target.value })}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                                            <textarea
                                                rows={4}
                                                placeholder="Email message (multi-line supported)"
                                                onChange={(e) => this.setState({ message: e.target.value })}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none resize-y"
                                            />
                                        </div>

                                        <div className="md:col-span-2">
                                            <label className="flex items-center gap-2 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    checked={this.state.send_email}
                                                    onChange={(e) => this.setState({ send_email: e.target.checked })}
                                                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                />
                                                <span className="text-sm font-medium text-gray-700">Send email notification (if allowed by player)</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="mt-6 flex justify-end">
                                        {this.state.sending ? (
                                            <div className="px-6 py-3 bg-gray-100 text-gray-500 rounded-lg flex items-center gap-2">
                                                <FaCoins className="animate-spin" />
                                                Sending Gift...
                                            </div>
                                        ) : (
                                            <button 
                                                onClick={this.sendGift}
                                                className="px-6 py-3 bg-gradient-to-r from-amber-500 to-yellow-500 text-white rounded-lg hover:from-amber-600 hover:to-yellow-600 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                                disabled={this.state.selectedPlayers.length === 0}
                                            >
                                                <FaPaperPlane />
                                                Send Gift to {this.state.selectedPlayers.length} Player{this.state.selectedPlayers.length !== 1 ? 's' : ''}
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {/* Upgrade Players Section */}
                                <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                                    <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                                        <FaUserShield className="text-indigo-600" />
                                        Upgrade Selected Players
                                    </h3>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="flex items-center gap-2 cursor-pointer">
                                                <input 
                                                    type="checkbox" 
                                                    checked={!this.state.adsEnabled}
                                                    onChange={() => this.setState({ adsEnabled: !this.state.adsEnabled })}
                                                    className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                                                />
                                                <span className="text-sm font-medium text-gray-700">Remove Ads</span>
                                            </label>
                                            <p className="text-xs text-gray-500 mt-1 ml-6">Disable advertisements for selected players</p>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">No Ads End Date</label>
                                            <input 
                                                type="datetime-local" 
                                                onChange={(e) => this.setState({ noAdsEndDate: e.target.value ? new Date(e.target.value).toISOString() : null })}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none text-sm"
                                                disabled={this.state.adsEnabled}
                                            />
                                            <p className="text-xs text-gray-500 mt-1">Leave empty for permanent no-ads status</p>
                                        </div>
                                    </div>

                                    <div className="mt-6 flex justify-end">
                                        {this.state.upgrading ? (
                                            <div className="px-6 py-3 bg-gray-100 text-gray-500 rounded-lg flex items-center gap-2">
                                                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Upgrading Players...
                                            </div>
                                        ) : (
                                            <button 
                                                onClick={this.upgradePlayers}
                                                className="px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-lg hover:from-indigo-600 hover:to-purple-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                                disabled={this.state.selectedPlayers.length === 0}
                                            >
                                                <FaUserShield />
                                                Upgrade {this.state.selectedPlayers.length} Player{this.state.selectedPlayers.length !== 1 ? 's' : ''}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </AdminLayout>

                {/* Send Bud Card Modal */}
                {this.state.showBudModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
                            {/* Modal Header */}
                            <div className="bg-gradient-to-r from-green-500 to-emerald-600 px-6 py-4 flex items-center justify-between">
                                <div className="flex items-center gap-3 text-white">
                                    <FaImage className="text-2xl" />
                                    <div>
                                        <h3 className="text-xl font-bold">Send Bud Card</h3>
                                        <p className="text-sm text-white/90">
                                            To: {this.state.selectedPlayerForBud?.username}
                                        </p>
                                    </div>
                                </div>
                                <button 
                                    onClick={this.closeBudModal}
                                    className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                                >
                                    <FaTimes className="text-xl" />
                                </button>
                            </div>

                            {/* Modal Body */}
                            <div className="p-6 overflow-y-auto max-h-[calc(90vh-200px)]">
                                <p className="text-gray-600 mb-4">
                                    Select a bud card to send to this player. The card will be generated and added to their collection.
                                </p>

                                <div className="mb-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Filter by Bud name</label>
                                    <input
                                        type="text"
                                        placeholder="Search a Bud..."
                                        value={this.state.budSearch}
                                        onChange={(e) => this.setState({ budSearch: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                    />
                                </div>

                                <div className="mb-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Card Power (optional)</label>
                                    <input
                                        type="number"
                                        min="1"
                                        placeholder="Leave empty to use default bud level power"
                                        value={this.state.card_power || ''}
                                        onChange={(e) => this.setState({ card_power: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">Used to force a higher power than the default level.</p>
                                </div>

                                {/* Buds Grid */}
                                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                    {filteredBuds.map(bud => (
                                        <div
                                            key={bud.bud_uuid}
                                            onClick={() => this.setState({ selectedBud: bud })}
                                            className={`cursor-pointer rounded-lg border-2 transition-all ${
                                                this.state.selectedBud?.bud_uuid === bud.bud_uuid
                                                    ? 'border-green-500 shadow-lg scale-105'
                                                    : 'border-gray-200 hover:border-green-300 hover:shadow-md'
                                            }`}
                                        >
                                            <div className="aspect-[3/4] relative overflow-hidden rounded-t-lg bg-gradient-to-br from-gray-100 to-gray-200">
                                                {bud.thumbnail_url || bud.img_url ? (
                                                    <img 
                                                        src={bud.thumbnail_url || bud.img_url} 
                                                        alt={bud.bud_name}
                                                        className="w-full h-full object-cover"
                                                    />
                                                ) : (
                                                    <div className="w-full h-full flex items-center justify-center">
                                                        <FaImage className="text-4xl text-gray-400" />
                                                    </div>
                                                )}
                                                {this.state.selectedBud?.bud_uuid === bud.bud_uuid && (
                                                    <div className="absolute inset-0 bg-green-500 bg-opacity-20 flex items-center justify-center">
                                                        <div className="bg-green-500 rounded-full p-2">
                                                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="p-3 bg-white">
                                                <h4 className="font-semibold text-gray-900 text-sm truncate">
                                                    {bud.bud_name}
                                                </h4>
                                                <p className="text-xs text-gray-600 mt-1 capitalize">
                                                    {bud.bud_level}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {filteredBuds.length === 0 && (
                                    <div className="text-center py-12 text-gray-500">
                                        <FaImage className="text-5xl mx-auto mb-3 text-gray-300" />
                                        <p>{this.state.budSearch ? 'No Bud matches this search' : 'No player Bud cards available'}</p>
                                    </div>
                                )}
                            </div>

                            {/* Modal Footer */}
                            <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
                                <button
                                    onClick={this.closeBudModal}
                                    className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
                                >
                                    Cancel
                                </button>
                                {this.state.sendingBud ? (
                                    <div className="px-6 py-2.5 bg-gray-100 text-gray-500 rounded-lg flex items-center gap-2">
                                        <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        Sending Card...
                                    </div>
                                ) : (
                                    <button
                                        onClick={this.sendBudCard}
                                        disabled={!this.state.selectedBud}
                                        className={`px-6 py-2.5 rounded-lg transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2 ${
                                            this.state.selectedBud
                                                ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-600 hover:to-emerald-700'
                                                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                        }`}
                                    >
                                        <FaPaperPlane />
                                        Send Card
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminPlayers)